<script setup>
    import {onMounted, ref} from 'vue'
    import axios from 'axios'

    const props = defineProps({
        displaymode: {
            type: String,
            required: false,
            default: 'widget'
        },
    })

    const taskLists = ref([])
    const addingTaskList = ref(false)
    const newTaskListName = ref('')

    const loadTaskLists = async () => {
        const res = await axios.get(route('api.task-list.index'))
        taskLists.value = res.data.task_lists
    }

    const createTaskList = async () => {
        await axios.post(route('api.task-list.store'), {
            name: newTaskListName.value
        })
        addingTaskList.value = false
        newTaskListName.value = ''
        await loadTaskLists()
    }

    onMounted(() => {
        loadTaskLists()
    })
</script>

<template>
    <div>
        <task-list-templates
            @reload="loadTaskLists"
        />
        <div
            class="mb-96"
            :class="displaymode === 'standalone' ? 'space-y-2' : ''"
        >
            <div
                v-for="taskList in taskLists"
                :key="taskList.id"
            >
                <task-list
                    :displaymode="props.displaymode"
                    :expanded="taskLists.length === 1"
                    :taskList="taskList"
                    @reload="loadTaskLists"
                ></task-list>
            </div>
            <div class="flex justify-center mt-4">
                <button-secondary
                    v-if="! addingTaskList"
                    size="sm"
                    @click="addingTaskList = true"
                >
                    Add task list
                </button-secondary>
                <div
                    v-if="addingTaskList"
                    class="flex space-x-2 items-center w-full p-4 rounded-wl bg-white"
                >
                    <input-text
                        v-model:content="newTaskListName"
                        label="Task list name"
                        autofocus
                        class="w-full !mb-0"
                    ></input-text>
                    <button-base
                        size="sm"
                        class="mt-6"
                        @click="addingTaskList = false"
                    >{{ _mft('shared:action.cancel') }}</button-base>
                    <button-success
                        size="sm"
                        class="mt-6"
                        @click="createTaskList"
                    >{{ _mft('shared:action.create') }}</button-success>
                </div>
            </div>

        </div>
    </div>
</template>
